import { ETabsActions } from '../../constants/actionTypes/tabs';
import { TReduxActions } from '../../types/redux';
import { ETabs } from '../../types/redux/tabs';

export function tabsReducer(state: ETabs = ETabs.Realtors, action: TReduxActions) {
  switch (action.type) {
    case ETabsActions.SET_ACTIVE_TAB:
      return action.payload;

    default:
      return state;
  }
}
